import { AriSourceService } from '~/services/ReportingService';

// The ARI models only exist in lux-analytics-prod, so a non-prod deploy would
// serve prod data. APP_ENV is 'test' on staging/dev, 'development' locally.
export function isAriSearchEnabled(): boolean {
  return window.configs?.APP_ENV !== 'test';
}

export type SearchBy = 'room_rate' | 'room_type' | 'rate_plan';

export const SEARCH_BY_LABELS: Record<SearchBy, string> = {
  room_rate: 'Room rate ID',
  room_type: 'Room type ID',
  rate_plan: 'Rate plan ID',
};

export const SOURCE_SERVICES: ReadonlyArray<AriSourceService> = ['derbysoft', 'siteminder', 'synxis'];

export const ACTIVITY_WINDOW_DAYS_BY_ROOM_RATE = 7;
export const ACTIVITY_WINDOW_DAYS_BY_ROOM_TYPE_OR_RATE_PLAN = 1;

export function activityWindowDays(searchBy: SearchBy): number {
  return searchBy === 'room_rate' ? ACTIVITY_WINDOW_DAYS_BY_ROOM_RATE : ACTIVITY_WINDOW_DAYS_BY_ROOM_TYPE_OR_RATE_PLAN;
}

// Synxis inventory is room-type grain with no rate plan, so those rows have a
// NULL room_rate_id and are invisible to a room-rate search.
export const ROOM_TYPE_GRAIN_MESSAGE_NAMES = ['OTA_HotelInvCountNotifRQ'];

export const ROOM_TYPE_GRAIN_INVENTORY_SOURCE = 'synxis';
